/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import NewsletterModel from 'cio/models/newsletter';
import Component from '@glimmer/component';
import { computed } from '@ember/object';
import { isEmpty } from '@ember/utils';
import { Task } from 'ember-concurrency';
import { inject as service } from '@ember/service';
import { TargetAudience } from 'cio/pods/broadcasts/newsletter/setup/recipients/index/controller';
import { formatNumberAndPluralize } from 'cio/helpers/format-number-and-pluralize';
import SubscriptionCenterService from 'cio/services/subscription-center';

interface NewsletterSetupRecipientsPreviewArgs {
  targetAudience: TargetAudience;
  newsletter: NewsletterModel;
  fetchRecipientsTask: Task<[], any>;
  sendingTotalPeople: number;
  peopleFilters: undefined | string;
}

export default class NewsletterSetupRecipientsPreview extends Component<NewsletterSetupRecipientsPreviewArgs> {
  @service subscriptionCenter!: SubscriptionCenterService;

  constructor(owner: unknown, args: NewsletterSetupRecipientsPreviewArgs) {
    super(owner, args);

    this.subscriptionCenter.initializeTask.perform();
  }

  @computed('args.{targetAudience,sendingTotalPeople,newsletter.filters}')
  get hasNoFilteredRecipients() {
    if (this.args.targetAudience !== TargetAudience.Subset) {
      return false;
    }
    // if user is sending by subset, recipient count may not be zero because the api queries for count without any filter
    // set at start. As such, we use filters property to determine if there are any segment-based recipients.
    return isEmpty(this.args.newsletter.filters) || this.args.sendingTotalPeople === 0;
  }

  get recipientsMessage() {
    let totalPeople = formatNumberAndPluralize([this.args.sendingTotalPeople, 'person']);
    let recipientsMessage =
      this.args.targetAudience === TargetAudience.Everyone
        ? `${totalPeople} total in this workspace`
        : `${totalPeople} currently match the conditions you added`;

    if (this.args.newsletter.sendToUnsubscribed) {
      recipientsMessage += ', including unsubscribed';
    }

    if (this.args.newsletter.subscriptionTopicId != null && this.subscriptionCenter.enabled) {
      let topic = this.subscriptionCenter.topics.find((topic) => topic.id === this.args.newsletter.subscriptionTopicId);

      recipientsMessage = `${recipientsMessage} are subscribed to ${topic?.name ?? 'unknown topic'}`;
    }

    return recipientsMessage;
  }
}
